module.exports = __webpack_public_path__ + "static/media/01.0b1c2050.png";